import * as React from "react";
import { Header, Button } from "semantic-ui-react";
import { Container } from "./styles";
import { Connectors } from "../SubQuadNavigation/Connectors/Connectors";
import * as Colour from "color";

interface IPieceProps {
	name: string;
	popoverText: string;

	handlePencil: () => void;
	handleQuestion: () => void;

	partnerLink?: string;
	colour?: string;

	up?: boolean;
	down?: boolean;
	left?: boolean;
	right?: boolean;
}
/** Gets an appropriate color for text on the the given color  */
const getColor = (bgColour: string): string => {
	return Colour(bgColour).light() ? "#111111" : "#F8F8F8";
	// return 'white';
};

const Piece: React.SFC<IPieceProps> = props => (
	<>
		{props.up && <Connectors.Up colour={props.colour} height={50} />}
		<Container
			colour={props.colour}
			style={{
				border: 0,
				color: "yellow"
				// color: getColor(props.colour)
			}}
		>
			{props.left && (
				<Connectors.Left height={50} colour={props.colour} />
			)}
			<div
				style={{
					flexGrow: 1,
					justifyContent: "center",
					alignItems: "center",
					alignSelf: "stretch",
					display: "flex",
					// flex: "1 0 100%",
					flex: '1 0 auto',
					width: '100%',
					right: props.left ? "54px" : "0",
					position: props.left ? "relative" : "initial",
					boxSizing:'border-box',
					padding:'55px 55px'
				}}
			>
				<div>
					<Header
						as="h3"
						textAlign="center"
						// data-tip={props.popoverText || "Hello"}
						style={{
							flexGrow: 1,
							color: getColor(props.colour)
						}}
					>
						{props.name}
					</Header>
					<div
						style={{
							textAlign: "center",
							marginLeft: "auto",
							marginRight: "auto"
						}}
					>
						<Button
							data-tip="I want to know more"
							as="a"
							color="black"
							icon="question"
							//TODO!
							//Open Modal with (props.popoverText) as the content
							onClick={props.handleQuestion}
							style={{ zIndex: 5 }}
						/>
						<Button
							data-tip="Write about my business"
							as="a"
							color="black"
							icon="pencil"
							onClick={props.handlePencil}
							style={{ zIndex: 5 }}
						/>

						{/* <Button as="a" color="black" icon="comment" />*/}
						{props.partnerLink && (
							<Button
								data-tip="Visit a recommended Partner site"
								as="a"
								color="black"
								icon="arrow right"
								href={props.partnerLink}
								target="_blank"
								style={{ zIndex: 5 }}
							/>
						)}
					</div>
				</div>
			</div>
			{props.right && (
				<Connectors.Right height={50} colour={props.colour} />
			)}
		</Container>
		{props.down && <Connectors.Down colour={props.colour} height={50} />}
		{/* <Connectors.Right height={50} colour="red" /> */}
	</>
);

export default Piece;

/*
Question Mark
- I want to know more, Take the user to some guiding questions and helpful info (to be provided?)

Pencil 
- Write about my business
- Enter their information for their own business

Comment

Arrow 
- Visit partner site 
*/



// WEBPACK FOOTER //
// ./src/components/Piece/Piece.tsx